export enum Operator {
	Equal = 'EQUAL',
	LessThan = 'LESS_THAN',
	LessThanOrEqual = 'LESS_THAN_OR_EQUAL',
	GreaterThan = 'GREATER_THAN',
	GreaterThanOrEqual = 'GREATER_THAN_OR_EQUAL',
	Like = 'LIKE',
	After = 'AFTER',
	AfterOrEqual = 'AFTER_OR_EQUAL',
	Before = 'BEFORE',
	BeforeOrEqual = 'BEFORE_OR_EQUAL',
	StartsWith = 'STARTS_WITH',
	Contains = 'CONTAINS',
	DoesNotContain = 'DOES_NOT_CONTAIN',
	EndsWith = 'ENDS_WITH',
	Unequal = 'UNEQUAL'
}
